export const LINES = 'lines';
export const COLUMNS = 'columns';
export const BARS = 'bars';
export const TABLE = 'table';
export const PIE = 'pie';
export const RADAR = 'radar';
export const NUMBER = 'number';
